import { render, staticRenderFns } from "./IAliPay.vue?vue&type=template&id=4938e04c&scoped=true&"
import script from "./IAliPay.vue?vue&type=script&lang=js&"
export * from "./IAliPay.vue?vue&type=script&lang=js&"
import style0 from "./IAliPay.vue?vue&type=style&index=0&id=4938e04c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4938e04c",
  null
  
)

export default component.exports